import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUniversity, FaPhone, FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      setVisible(prevScrollPos > currentScrollPos || currentScrollPos < 10);
      setPrevScrollPos(currentScrollPos);
      setScrolled(currentScrollPos > 10);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos, visible]);
  
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <nav className={`navbar ${visible ? 'visible' : 'hidden'} ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="logo" onClick={() => setIsOpen(false)}>
          {/* Replace the icon with your image */}
          <img src={require('../assets/LOGO_U2S.jpg')} alt="U2S Logo" className="logo-img" />
          <div className="logo-text">
            <span>Université des Sciences de Sébikotane</span>
            <small>U2S - Excellence Académique</small>
          </div>
        </Link>
        
        <div className={`nav-links ${isOpen ? 'active' : ''}`}>
          <Link to="/">Accueil</Link>
          <Link to="/about">L'Université</Link>
          <Link to="/admissions">Admissions</Link>
          <Link to="/contact">Contact</Link>
          
          <div className="nav-contact">
            <a href="tel:+221706863636" className="contact-link">
              <FaPhone className="phone-icon" />
              <span>+221 70 686 36 36</span>
            </a>
          </div>
        </div>
        
        <button 
          className="menu-toggle" 
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;